import { ValueObject } from '@nx-smartmonkey/shared/domain';
import { ProjectCustomerEmailTypes } from '../ProjectDTO';
import { ProjectView } from '../projectView/ProjectView';
import { ProjectCustomerEmailItem } from './ProjectCustomerEmailItem';

interface ProjectCustomerEmailProps {
  stop_created?: ProjectCustomerEmailItem;
  route_started?: ProjectCustomerEmailItem;
  stop_approaching?: ProjectCustomerEmailItem;
  stop_completed?: ProjectCustomerEmailItem;
  stop_canceled?: ProjectCustomerEmailItem;
  pickup_created?: ProjectCustomerEmailItem;
  pickup_approaching?: ProjectCustomerEmailItem;
  pickup_completed?: ProjectCustomerEmailItem;
  pickup_canceled?: ProjectCustomerEmailItem;
}

export class ProjectCustomerEmail extends ValueObject<ProjectCustomerEmailProps> {
  get stop_created(): ProjectCustomerEmailItem | undefined {
    return this.props.stop_created;
  }
  set stop_created(stopCreated: ProjectCustomerEmailItem | undefined) {
    this.props.stop_created = stopCreated;
  }
  get route_started(): ProjectCustomerEmailItem | undefined {
    return this.props.route_started;
  }
  set route_started(routeStarted: ProjectCustomerEmailItem | undefined) {
    this.props.route_started = routeStarted;
  }
  get stop_approaching(): ProjectCustomerEmailItem | undefined {
    return this.props.stop_approaching;
  }
  set stop_approaching(stopApproaching: ProjectCustomerEmailItem | undefined) {
    this.props.stop_approaching = stopApproaching;
  }
  get stop_completed(): ProjectCustomerEmailItem | undefined {
    return this.props.stop_completed;
  }
  set stop_completed(stopCompleted: ProjectCustomerEmailItem | undefined) {
    this.props.stop_completed = stopCompleted;
  }
  get stop_canceled(): ProjectCustomerEmailItem | undefined {
    return this.props.stop_canceled;
  }
  set stop_canceled(stopCanceled: ProjectCustomerEmailItem | undefined) {
    this.props.stop_canceled = stopCanceled;
  }
  get pickup_created(): ProjectCustomerEmailItem | undefined {
    return this.props.pickup_created;
  }
  set pickup_created(pickupCreated: ProjectCustomerEmailItem | undefined) {
    this.props.pickup_created = pickupCreated;
  }
  get pickup_approaching(): ProjectCustomerEmailItem | undefined {
    return this.props.pickup_approaching;
  }
  set pickup_approaching(pickupApproaching: ProjectCustomerEmailItem | undefined) {
    this.props.pickup_approaching = pickupApproaching;
  }
  get pickup_completed(): ProjectCustomerEmailItem | undefined {
    return this.props.pickup_completed;
  }
  set pickup_completed(pickupCompleted: ProjectCustomerEmailItem | undefined) {
    this.props.pickup_completed = pickupCompleted;
  }
  get pickup_canceled(): ProjectCustomerEmailItem | undefined {
    return this.props.pickup_canceled;
  }
  set pickup_canceled(pickupCanceled: ProjectCustomerEmailItem | undefined) {
    this.props.pickup_canceled = pickupCanceled;
  }
  private constructor(props: ProjectCustomerEmailProps) {
    super(props);
  }

  static create(props: ProjectCustomerEmailProps): ProjectCustomerEmail {
    return new ProjectCustomerEmail(props);
  }

  getCustomerAvailableEmails = (view?: ProjectView) => {
    const trackingEmails: Partial<Record<ProjectCustomerEmailTypes, ProjectCustomerEmailItem>> = {};
    Object.entries(this.getValue()).forEach(([emailType, emailItem]) => {
      // Only showing the pickup emails if pickups are available in project view constraints.
      if (
        !(
          emailType === `pickup_created` ||
          emailType === `pickup_approaching` ||
          emailType === `pickup_completed` ||
          emailType === `pickup_canceled`
        ) ||
        view?.constraints.pickups
      ) {
        trackingEmails[emailType as ProjectCustomerEmailTypes] = emailItem as ProjectCustomerEmailItem;
      }
    });

    return trackingEmails;
  };

  getCustomerAvailableEmailsTypes = (view?: ProjectView) => {
    return Object.keys(this.getCustomerAvailableEmails(view)) as ProjectCustomerEmailTypes[];
  };

  countCustomerAvailableEmails = (view?: ProjectView) => {
    return Object.keys(this.getCustomerAvailableEmails(view)).length;
  };

  countCustomerEnabledEmails = (view?: ProjectView) => {
    return Object.values(this.getCustomerAvailableEmails(view)).filter((emailItem) => emailItem.enabled).length;
  };

  isEmailEnabled = (emailType: ProjectCustomerEmailTypes, view?: ProjectView) => {
    return this.getCustomerAvailableEmails(view)[emailType]?.enabled;
  };
}
